/**
 * External dependencies
 */
import { Component } from 'react'
import classnames from 'classnames'
import { range } from '~bookwormgb/util/range'

/**
 * Wordpress dependencies
 */
import {
	Fragment,
} from '@wordpress/element'

class DealProduct extends Component {

	render() {
		const {
			limit = 1,
			placeholder = 0,
			showImage = true,
			showProductFormat = true,
			showProductTitle = true,
			showProductAuthor = true,
			showProductPrice = true,
			showProductRating = true,
			showTimer = true,
			showTimerTitle = true,
			showProgressBar = true,
			showDiscountBadge = true,
		} = this.props

		const output = (
			<div className={ classnames( [ `deal-products-placeholder products` ], {} ) }
			>
				{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
					return(
						<div className="product product__card product__card-v2" key={ `product-${i}` }>
							<div className="px-md-5 py-md-6 p-4 border border-primary border-width-2">							
								<div className="woocommerce-loop-product__thumbnail py-8 position-relative">
									{ showDiscountBadge && 
										<div className="progress bg-light rounded-circle position-absolute right-0 top-0" style={ { height:'100px', width:'100px' } }></div>
									}

									{ showImage &&
										<div className="progress bg-light" style={ {
											height:'300px', width:'200px', marginLeft: 'auto', marginRight: 'auto' 
										} }></div>
									}
								</div>
								
								<div className="woocommerce-loop-product__body">
									<div className="mb-3">
										{ showProductFormat &&
											<div className="badge badge-shadow w-50">
												<div className="progress bg-light"></div>
											</div>
										}
										{ showProductTitle &&
											<div className="badge badge-shadow w-80">
												<div className="progress bg-light"></div>
											</div>
										}
										{ showProductAuthor &&
											<div className="badge badge-shadow w-50 d-block mb-2">
												<div className="progress bg-light"></div>
											</div>
										}
										{ showProductPrice &&
											<div className="badge badge-shadow w-50">
												<div className="progress bg-light"></div>
											</div>
										}
										{ showProductRating &&
											<div className="badge badge-shadow w-50 d-block mb-2">
												<div className="progress bg-light"></div>
											</div>
										}

										
									</div>
									{ showTimer &&
										<Fragment>
											{ showTimerTitle &&
												<div className="badge badge-shadow w-60 d-block">
													<div className="progress bg-light"></div>
												</div>
											}
											<div className="d-flex align-items-stretch justify-content-between mt-4">
												<div className="py-2d75 bg-light rounded-md" style={ { width:'65px', height:'51px' } }></div>
												
												<div className="border-left pr-3 pr-md-0">&nbsp;</div>
												
												<div className="py-2d75 bg-light rounded-md" style={ { width:'65px', height:'51px' } }></div>
												
												<div className="border-left pr-3 pr-md-0">&nbsp;</div>
												
												<div className="py-2d75 bg-light rounded-md" style={ { width:'65px', height:'51px' } }></div>
												
												<div className="border-left pr-3 pr-md-0">&nbsp;</div>
												
												<div className="py-2d75 bg-light rounded-md" style={ { width:'65px', height:'51px' } }></div>
											</div>
										</Fragment>
									}
									{ showProgressBar &&
										<Fragment>
											<div className="d-flex justify-content-between mb-2d75 mt-5">
												<span className="badge badge-shadow rounded-pill bg-light d-inline-block" style={ { width:'130px', height:'20px' } }></span>
												
											</div>
											<div className="progress bg-light">
												<div className="progress-bar w-60" role="progressbar" style={ { backgroundColor: '#ececec' } }></div>
											</div>
										</Fragment>
									}
								</div>
							</div>
						</div>
					)
				} ) }
			</div>
		)

		return output
	}
}

export default DealProduct